<template>
    <div v-loading = 'loading' class = "content-container"></div>
</template>

<script>
import { useCommonStore } from '@/stores/CommonStore.ts';
import { mapActions, mapState } from 'pinia';
import { ElNotification } from 'element-plus';

import gql from "graphql-tag";
import { pns_graphal_client } from "@/utils/graphQLRequests.js";

export default{
    async mounted(){
        this.loading = true;
        try{
            // Check whether has query params. 
            // If so, set top bar, store query params, decide flow type
            if(this.$route.query && Object.keys(this.$route.query).length > 0){
                // 1. save query info in localStorage: for user refresh on other pages in single page flow
                localStorage.setItem('pns_single_page_query', JSON.stringify(this.$route.query));

                // ******************************** query params ********************************

                // --------------- order info and auth params ----------------
                // accession_id: Number String,
                // sample_id: Number String,
                // token: String,
                // --------------- order info and auth params Ends ----------------

                // --------------- flow type params ----------------
                // direct_to_blooddraw: Boolean String,
                // amount_to_pay: Number String,
                // payment_prioritized: Boolean String,
                // --------------- flow type params Ends ----------------

                // --------------- other params ----------------
                // count: Number String,
                // from: ENUM String, // might be "email", no value or other ENUMs in the future
                // --------------- other params Ends ----------------

                // ******************************** query params Ends ********************************
                // NOTES: flow type params priority order: direct_to_blooddraw > amount_to_pay / payment_prioritized
                // NOTES: ONLY ONE of amount_to_pay (Number String), payment_prioritized (Boolean String) can be true.

                // 2. set data in CommonStore: for the top header information
                this.setAccessionId(this.$route.query.accession_id);
                this.setSampleId(this.$route.query.sample_id);
                this.setJwtToken(this.$route.query.token);

                // 3. check whether the order is canceled or patient is deactivated, by calling graphQL
                try{
                    const CHECK_CANCELED_ORDER_VIA_SAMPLE = gql `
                        query checkWhetherOrderIsCanceledViaSample( $sampleIdList:[String!] ){
                            patientOrder(orderInput:{ sampleIdList: $sampleIdList }){
                                orders{
                                    order{
                                        isPatientActive
                                        isCanceled
                                        patientId
                                    }
                                }
                            }
                        }
                    `;
                    const { data, errors } = await pns_graphal_client.query({
                    query: CHECK_CANCELED_ORDER_VIA_SAMPLE,
                    variables: {
                        sampleIdList: [this.sample_id]
                    },
                    context:{
                        headers:{
                            Authorization: `Bearer ${this.$route.query.token}`
                        }
                    }
                    });
                    //As graphql won't trhow an error automatically, we need to manually check the error.
                    if(errors && errors.length > 0){
                        throw new Error(errors.map(err => err.message).join(' | '));
                    }

                    // set cutomized user id for data track package
                    const patient_id = data?.patientOrder?.orders?.[0]?.order?.patientId; 
                    if(process.env.VUE_APP_ENV == 'production' && patient_id){
                        // set user id (patient_id) for Sentry
                        this.addPatientIDToSentry(patient_id);
                        // set user id (patient_id) for full story
                        this.addPatientIDToFullStory(patient_id);
                    }

                    setTimeout(() => {
                        
                    }, 20000);
                    
                    // if the order is cancelled, directly jump to /order_cancelled.
                    if(data?.patientOrder?.orders?.[0]?.order?.isCanceled){
                        this.$router.push('/order_cancelled');
                        return;
                    }
                    // if the patient is deactivated, directly jump to /order_cancelled.
                    if(!data?.patientOrder?.orders?.[0]?.order?.isPatientActive){
                        this.$router.push('/empty_state');
                        return;
                    }
                }catch(err){
                    console.log('check whether the order is canceled error:', err);
                    this.$router.push('/failed');
                    return;
                }
                // If not canceled order:    
                if(this.$route.query.direct_to_blooddraw == 'true'){
                // 4. If direct_to_blooddraw == 'true': directly redirect to bloodDrawMedia page
                    this.$router.push({
                        name:'bloodDrawMedia',
                        query:this.$route.query
                    });
                }else if(this.$route.query.payment_prioritized == 'true' || this.$route.query.amount_to_pay){
                // 5. If payment_prioritized == 'true': need to show payment page first
                //    If amount_to_pay (Number String): from LIS
                // -> always first show payment page.
                // NOTES: MUST pass full query in URL, as payment page need to use flow type params
                    this.$router.push({
                        name:'paymentMedia',
                        query:this.$route.query
                    });
                }else{
                // 6. Regular Flow: first show Basic and Shipping Information Page
                    this.$router.push({
                        name:'shippingAddressMedia',
                        query:this.$route.query
                    });
                }
            }else{
            // If no query params, DON'T allow any operations: error notification, clear query in localStorage, and redirect to /failed GeneralFailed page

                //remove previous query info in localStorage: in case there is a previous record there
                localStorage.removeItem('pns_single_page_query');
                ElNotification({
                    title: 'Error',
                    customClass: "errorNotification",
                    message: 'No query information found.',
                    type: 'error',
                    duration: 0,
                });
                this.$router.push('/failed');
            }
        }catch(err){
            console.log('SinglePageFlowMedia mounted error: ', err);
            ElNotification({
                title: 'Error',
                customClass: "errorNotification",
                message: err?.message ?? 'SinglePageFlowMedia mounted error',
                type: 'error',
                duration: 0,
            });
            this.$router.push('/failed');
        }finally{
        // guarantee to end loading
            this.loading = false;
        }
    },
    data(){
        return {
            loading: false,
        }
    },
    computed:{
        ...mapState(()=>useCommonStore(), [
            'sample_id',
        ]),
    },
    methods:{
        ...mapActions(()=>useCommonStore(),[
            'setAccessionId',
            'setSampleId',
            'setJwtToken',
            'addPatientIDToSentry',
            'addPatientIDToFullStory'
        ]),
    }
}
</script>

<style scoped>
.content-container{
    min-height: calc(100vh - 77px);
    padding-bottom: 114px;
}
@media only screen and (max-width: 767px){
    .content-container{
        padding-bottom: 104px;
    }
}
</style>